import { render, staticRenderFns } from "./UploadOrderCard.vue?vue&type=template&id=4b4d9845&scoped=true&"
import script from "./UploadOrderCard.vue?vue&type=script&lang=js&"
export * from "./UploadOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadOrderCard.vue?vue&type=style&index=0&id=4b4d9845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d9845",
  null
  
)

export default component.exports